// Cloudinary URLs for optimized image delivery
import { IMAGES } from '../constants/cloudinaryImages';

const logo = IMAGES.logo;
const banner = IMAGES.banner;
const jobify = IMAGES.projects.jobify;
const eventimg = IMAGES.projects.event;
const contactimg = IMAGES.projects.contact;
const shoe = IMAGES.projects.shoeStore;
const pizza = IMAGES.projects.pizza;
const portfolio = IMAGES.projects.portfolio;
const weather = IMAGES.projects.weather;
const youtube = IMAGES.projects.youtube;

export {
    logo,
    banner,
    jobify,
    eventimg,
    contactimg,
    shoe,
    pizza,
    portfolio,
    weather,
    youtube,
}